import { render, staticRenderFns } from "./save-preset-form.vue?vue&type=template&id=0b7137e4"
import script from "./save-preset-form.vue?vue&type=script&lang=js"
export * from "./save-preset-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports